import {Injectable} from '@angular/core';
import {PlayerServiceProvider} from '../modules/core/services/player-service/player-service';
import {DisplayServiceProvider} from '../modules/core/services/display-service/display-service';
import {
  TableConfig
} from '../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/table/interfaces/table-config.interface';
import {ENVIRONMENT} from '../../environments/environment';
import {
  ListConfig
} from '../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/list-config.interface';
import {
  DetailsConfig
} from '../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/details/interfaces/details-config.interface';

@Injectable()
export class GenericDataViewService {
  private baseUrlEngine = ENVIRONMENT.engineUrl;
  private baseUrlBackend = ENVIRONMENT.apiBaseUrl;

  constructor(private playerService: PlayerServiceProvider, private displayService: DisplayServiceProvider) {}
  // function returns any because many different types of config can be passed via user screens
  public getConfig(viewId: string): any {
    return this.displayService.getScreenByViewId(viewId);
  }

  public setConfigBaseUrl(config: TableConfig | ListConfig | DetailsConfig): void {
    const url: string = config.dataSourceConfig.onlineDataSourceUrl;
    if (this.checkIfContainsSubstring(url, '${backend}')) {
      config.dataSourceConfig.onlineDataSourceUrl = url.replace('${backend}/', this.baseUrlBackend);
    } else if (this.checkIfContainsSubstring(url, '${engine}')) {
      config.dataSourceConfig.onlineDataSourceUrl = url.replace('${engine}/', this.baseUrlEngine);
    }
  }

  private checkIfContainsSubstring(string: string, substring: string): boolean {
    return string.indexOf(substring) !== -1;
  }

  public getBaseUrl(config: TableConfig | ListConfig | DetailsConfig): string {
    const baseUrl = config.dataSourceConfig && config.dataSourceConfig.onlineDataSourceBaseUrl;
    if (baseUrl === 'ENGINE') {
      return this.baseUrlEngine;
    }

    if (baseUrl === 'BACKEND') {
      return this.baseUrlBackend;
    }
  }

  public getEngineUrl(): string {
    return this.baseUrlEngine;
  }

  public getBackendUrl(): string {
    return this.baseUrlBackend;
  }

  public getDefaultDataViewTimer(): number {
    return ENVIRONMENT.defaultDataViewTimeout;
  }
}



// WEBPACK FOOTER //
// ./src/generic-data-view/generic-data-view.service.ts